import { Outlet } from "react-router-dom"
import { HeaderTab } from "./HeaderTab"
import type { SectionTab } from "../../lib/navigation"

interface SectionLayoutProps {
  tabs: SectionTab[]
}

export function SectionLayout({ tabs }: SectionLayoutProps) {
  return (
    <div className="flex flex-col">
      {/* Section tabs */}
      <div className="section-header px-2 pt-0 pb-0">
        <nav className="flex gap-1 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <HeaderTab key={tab.to} to={tab.to} end={tab.end}>
              {tab.label}
            </HeaderTab>
          ))}
        </nav>
      </div>

      {/* Page content */}
      <Outlet />
    </div>
  )
}
